import { useEffect } from "react";

const PageFail = ({ amount, trackingID, onRedirect }) => {
    useEffect(() => {
      // Initialize on component mount
      init();
      eventAttachments();
      
      // Cleanup on component unmount (equivalent to componentWillUnmount)
      return () => {
        // Any cleanup code if needed
      };
    }, []);
    
    const init = () => {
      // Remove QR code button if it exists in the DOM
      const btnQrCode = document.getElementById('btnQrCode');
      if (btnQrCode) {
        btnQrCode.remove();
      }
      
      // Show the modal
      // Using a direct DOM manipulation here for Bootstrap modal
      // In a real React app, you would use state to control the modal
      const modalConfirm = document.getElementById('modalConfirm');
      if (modalConfirm && window.$ && window.$.fn && window.$.fn.modal) {
        window.$(modalConfirm).modal('show');
      }
    };
    
    const eventAttachments = () => {
      // Handle modal hide event
      if (window.$ && window.$.fn && window.$.fn.modal) {
        window.$("#modalConfirm").on('hide.bs.modal', function () {
          // Navigate to tee booking page
          if (onRedirect) {
            onRedirect();
          }
        });
      }
    };
  
    return (
      <div className="container">
        <div className="margin-t200 text-center">
          <h1><i className="fa fa-spinner fa-spin"></i></h1>
        </div>
        <div id="modalConfirm" className="modal fade" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content margin-t150">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xs-12 text-center">
                    <i className="fa fa-times-circle-o fa-4x text-muted" aria-hidden="true"></i>
                  </div>
                </div>
                <div className="row wow fadeInUp animated" data-wow-delay="0.1s">
                  <div className="col-xs-12">
                    <h4 id="txtAmount" className="text-center text-muted">{amount}</h4>
                    <h5 className="text-center text-muted">Oops! Transaction Failed</h5>
                    <h6 id="txtTrackingID" className="text-center">{trackingID}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  export default PageFail;
